export const groupBy = (arr: any[], getKey: (any) => string) =>
  arr?.reduce((acc, item) => {
    const groupByKey = getKey(item);
    if (!acc[groupByKey]) {
      acc[groupByKey] = [];
    }
    acc[groupByKey].push(item);
    return acc;
  }, {}) || [];
